import { type Event, EventAdapter, type EventDTO } from '@/5_entities/Event'
import { type Venue, VenueAdapter, type VenueDTO, venuesHandbook } from '@/5_entities/Venue'
import type { SearchResultItem } from '@/6_shared/model'
import type { SearchDTO, Search } from './type'

export const SearchAdapter = (data: SearchDTO): Search => {
  const { events, venues } = data

  return {
    events: events.items.reduce(
      (acc, item) => {
        const isEvent = item.type === 'event'

        isEvent &&
          acc.push({
            type: 'event',
            object: new EventAdapter(item.object as EventDTO)
          })

        !isEvent && venuesHandbook.add(item.object as VenueDTO)

        return acc
      },
      [] as SearchResultItem<'event', Event>[]
    ),
    venues: venues.items.reduce(
      (acc, item) => {
        acc.push({
          type: 'venue',
          object: new VenueAdapter(item.object as VenueDTO)
        })

        return acc
      },
      [] as SearchResultItem<'venue', Venue>[]
    )
  }
}
